import React from 'react';
import styled from 'styled-components';

import { ConfirmationModal, ModalPosition, Container, Button } from 'ui/components/styled';

export const ConfirmRemoveCategory = ({ params, ...rest }) => (
  <ConfirmationModal
    padding="1.5rem 2rem 1.6rem"
    content={ModalContent}
    contentProps={{ params }}
    position={ModalPosition.TOP_CENTER}
    top="25%"
    width="45%"
    maxWidth="680px"
    {...rest}
  />
);

const ModalContent = ({ children, params, onClose, onConfirm, preventConfirm }) => (
  <>
    {children ? (
      <Content mb="l">{children}</Content>
    ) : (
      <>
        <Title mb="xs">Delete Category</Title>
        <Content mb="l">
          Are you sure you want to delete category
          {params?.category?.name ? ` "${params.category.name}" ` : ''}? It would also delete all
          monitors for all customers.
        </Content>
      </>
    )}
    <Container flexDirection="row" justifyContent="flex-end">
      <Button
        variant="danger"
        width="30%"
        boxShadow="none"
        mr="m"
        onClick={onConfirm}
        disabled={preventConfirm}
      >
        Delete
      </Button>
      <Button width="30%" onClick={onClose}>
        Cancel
      </Button>
    </Container>
  </>
);

const Title = styled(Container)`
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.04em;
  line-height: 26px;
  letter-spacing: 0.04em;
  color: #333;
`;

const Content = styled(Container)`
  font-weight: normal;
  font-size: 14px;
  letter-spacing: 0.04em;
  line-height: 26px;
  letter-spacing: 0.04em;
  color: #f74c4c;
`;
